import NetworkChartArt from "../components/svg/NetworkChartArt";

export default function HeroScreen() {
  return (
    /* no reveal on the hero: its headline must paint immediately — it is
       the page's LCP element */
    <section id="hero">
      <div className="hero-art">
        <NetworkChartArt />
      </div>

      <div className="content">
        <h1>
          Real AI,
          <br />
          already <span className="hero-highlight">flying.</span>
        </h1>
        <p>
          Our differentiation is the fusion of AI, financial and mathematical
          modeling, and business insight in one deployed decision system.
        </p>
      </div>

    </section>
  );
}
